function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("mask", {
  id: "chat_svg__a",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 5a2 2 0 00-2 2v25.004a2 2 0 002 2h5.818l3.457 4.343a.5.5 0 00.783 0l3.458-4.343H38a2 2 0 002-2V7a2 2 0 00-2-2H2z"
}));
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.818 34.004l1.956-1.557a2.5 2.5 0 00-1.956-.943v2.5zm3.457 4.343L9.32 39.904l1.955-1.557zm.783 0l1.956 1.557-1.956-1.557zm3.458-4.343v-2.5a2.5 2.5 0 00-1.956.943l1.956 1.557zM2.5 7a.5.5 0 01-.5.5v-5A4.5 4.5 0 00-2.5 7h5zm0 25.004V7h-5v25.004h5zm-.5-.5a.5.5 0 01.5.5h-5a4.5 4.5 0 004.5 4.5v-5zm5.818 0H2v5h5.818v-5zm5.413 5.285l-3.457-4.342-3.912 3.114 3.458 4.343 3.911-3.115zm-3.129 0a2 2 0 013.13 0L9.32 39.904a3 3 0 004.694 0l-3.912-3.115zm3.458-4.342l-3.458 4.342 3.912 3.115 3.457-4.343-3.911-3.114zM38 31.504H15.516v5H38v-5zm-.5.5a.5.5 0 01.5-.5v5a4.5 4.5 0 004.5-4.5h-5zM37.5 7v25.004h5V7h-5zm.5.5a.5.5 0 01-.5-.5h5A4.5 4.5 0 0038 2.5v5zm-36 0h36v-5H2v5z",
  fill: "params(fill)",
  mask: "url(#chat_svg__a)"
});
function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}
export default SvgChat;